/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 21/2/2022
 */

import FormItem from "@/core/modules/coach/Resources/Forms/model/FormItem";
import {Type} from "@qwoach/class-transformer-wrapper";
import WorkflowDocuments from "@shared/Workflow/WorkflowDocuments";

//WARNING: don't remove! both imports below must stay here! Otherwise it breaks imports by creating unresolved circular dependency in DocSignTemplateItem. Research for a better way to overcome that.
import DocSignDocument from "@/core/modules/DocSign/data/DocSignDocument/DocSignDocument";
import DocSignTemplateItem from "@/core/modules/DocSign/data/DocSignTemplateItem";

export default class TraumaWorkflowDocumentsWrapper extends WorkflowDocuments {


	@Type(() => FormItem)
	briefIntakeForm: null

	@Type(() => FormItem)
	detailedIntakeForm: null


	@Type(() => FormItem)
	safetyRiskAssessment: null

	@Type(() => DocSignTemplateItem)
	crisisManagementPlan:null

	@Type(() => DocSignTemplateItem)
	clientSafetyPlan:null

	@Type(() => FormItem)
	recoveryGoalsWorksheet: null

	@Type(() => FormItem)
	activitiesOfDailyLiving: null


	getForms(){
		return [
			this.briefIntakeForm,
			this.detailedIntakeForm,
			this.safetyRiskAssessment,
			this.recoveryGoalsWorksheet,
			this.activitiesOfDailyLiving
		]
	}

	getDocSignTemplates(){
		return [
			this.crisisManagementPlan,
			this.clientSafetyPlan,
		]
	}


}
